// Shared formatters — previously duplicated across revenue/analytics components.

const gbp = new Intl.NumberFormat('en-GB', {
  style: 'currency',
  currency: 'GBP',
});

const gbpWhole = new Intl.NumberFormat('en-GB', {
  style: 'currency',
  currency: 'GBP',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

export function formatCurrency(value, { whole = false } = {}) {
  const n = typeof value === 'number' ? value : parseFloat(value);
  if (!Number.isFinite(n)) return '—';
  return whole ? gbpWhole.format(n) : gbp.format(n);
}

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

// Shape-aware: 'YYYY-MM' -> 'Jan 25', 'YYYY-MM-DD' -> '5 Aug'.
// Daily periods used to fall through the month branch and render every day
// of a month as the same 'Aug 26' label.
export function formatPeriod(period, { weekly = false } = {}) {
  if (typeof period !== 'string') return String(period ?? '');
  const [year, month, day] = period.split('-');
  const m = parseInt(month, 10);
  if (!year || !Number.isFinite(m) || m < 1 || m > 12) return period;
  if (day !== undefined) {
    const d = parseInt(day, 10);
    if (!Number.isFinite(d)) return period;
    return weekly ? `w/c ${d} ${MONTHS[m - 1]}` : `${d} ${MONTHS[m - 1]}`;
  }
  return `${MONTHS[m - 1]} ${year.slice(2)}`;
}

// Magnitude-aware axis labels: '£12k' for big numbers, '£110' for small.
// The old formatters printed '£109.94999999999999' under 1000 on one chart
// and forced everything to '0k'/'1k'/'2k' on another.
export function formatAxisCurrency(value) {
  const n = typeof value === 'number' ? value : parseFloat(value);
  if (!Number.isFinite(n)) return '—';
  if (Math.abs(n) >= 10000) return `£${Math.round(n / 1000)}k`;
  return `£${Math.round(n).toLocaleString('en-GB')}`;
}

export function formatPercent(value, digits = 1) {
  const n = typeof value === 'number' ? value : parseFloat(value);
  if (!Number.isFinite(n)) return '—';
  return `${n.toFixed(digits)}%`;
}
